import { createFileRoute } from '@tanstack/react-router';
import { BankReconciliationsPage } from '@/features/bank-reconciliations/components/BankReconciliationsPage';

export const Route = createFileRoute('/$commiteeSlug/accounting/bank-reconciliations/{-$id}')({
  component: BankReconciliationsPage,
});
